// extracted by mini-css-extract-plugin
module.exports = {"note":"sCnDY2","button":"yoQE_e","body":"_6FtuM","icon":"bqcF4y"};